import {
  StyledCameraButtonButton,
  StyledCameraButtonButtonImg,
  StyledCameraButtonButtonImgContainer,
  StyledCameraButtonContainer,
  StyledCameraButtonFramed,
  StyledCameraButtonFramedContent,
  StyledCameraButtonSectionButton,
  StyledCameraButtonTitle,
} from './styled'
import { SelfieBoothType } from '../../../types/selfiebooth'
import { withTranslation } from 'react-i18next'
import useFileUpload from '../hooks/useFileUpload'

interface CameraButtonProps {
  selfiebooth: SelfieBoothType|any;
  startCamera: () => void;
  onUploadPhoto: (fileUrl: string) => void;
  isModal: boolean;
  t: any;
}

const CameraButton = ({ selfiebooth, startCamera, onUploadPhoto, isModal, t }: CameraButtonProps) => {
  const { part: infos } = selfiebooth;
  const { inputRef, openFilePicker, handleFileUpload } = useFileUpload(onUploadPhoto);

  return <>
    <StyledCameraButtonContainer $isModal={isModal}>
      <StyledCameraButtonFramed>
        <StyledCameraButtonFramedContent>
          <StyledCameraButtonTitle>{selfiebooth.part.welcomeMessage}</StyledCameraButtonTitle>
          <StyledCameraButtonButtonImgContainer>
            <StyledCameraButtonButtonImg
              src={`/static/photobooth/welcome/selfie${infos.welcomeImage || '1'}.svg`}
              onClick={startCamera}
            />
          </StyledCameraButtonButtonImgContainer>
          <StyledCameraButtonSectionButton>
            <StyledCameraButtonButton onClick={startCamera}>
              <label>{infos.labelStartCamera || t('photobooth.camera')}</label>
            </StyledCameraButtonButton>
          </StyledCameraButtonSectionButton>
          {infos.inputPhoto && <>
            <StyledCameraButtonSectionButton>
              <StyledCameraButtonButton onClick={openFilePicker}>
                <label>{infos.inputPhotoText || t('photobooth.uploadPicture')}</label>
              </StyledCameraButtonButton>
              <input
                type="file"
                ref={inputRef}
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileUpload}
              />
            </StyledCameraButtonSectionButton>
          </>}
        </StyledCameraButtonFramedContent>
      </StyledCameraButtonFramed>
    </StyledCameraButtonContainer>
  </>
}

export default withTranslation()(CameraButton);